module.exports = __webpack_public_path__ + "static/media/add.d9eed5b9.svg";